let env = {
    env: '',
    baseUrl: '',
    // online_url: '',
    agentId: '',
    scancodeUrl:'',
    dify_url:'https://ai.vipzhhr.com',
    dify_key:'WBBXMFsTx8UPIZwD',
    is_local: function() {
        return this.env == 'local'
    },
    is_dev: function() {
        return this.env == 'dev'
    },
    is_test: function() {
        return this.env == 'test'
    },
    is_prod: function() {
        return this.env == 'prod'
    },
    init: function() {
        let url = window.location.href
        if (url.indexOf('localhost') >= 0) {
            this.env = 'local'
            this.baseUrl = 'https://testv3.vipzhhr.com'
            // this.baseUrl = 'http://localhost:8000'
            this.scancodeUrl='https://testv3front.vipzhhr.com/#'
            // this.online_url = "http://localhost:8080"
            // this.agentId = "1000004"
            // this.baseUrl = 'http://zhtest.com'
        } else if (url.indexOf('testv2front') >= 0 || url.indexOf('salary.vipzhhr') >= 0) {
            this.env = 'dev'
            // this.env = 'prod'
            this.baseUrl = 'https://testv1.vipzhhr.com'
            this.scancodeUrl='https://testv2front.vipzhhr.com/#'
            // this.online_url = "http://testworkwechat.vipzhhr.com"
            // this.agentId = "1000004"
        } else if(url.indexOf('testv3front') >= 0){
            this.env = 'dev'
            this.baseUrl = 'https://testv3.vipzhhr.com'
            this.scancodeUrl='https://testv3front.vipzhhr.com/#'
        } else if(url.indexOf('saas-merchant') >= 0){
            this.env = 'prod'
            this.baseUrl = 'https://saas-api.vipzhhr.com'
            this.scancodeUrl='https://workwechat.vipzhhr.com/#'
        } else {
            this.env = 'prod'
            this.baseUrl = 'https://www.vipzhhr.com'
            this.scancodeUrl='https://workwechat.vipzhhr.com/#'
            // this.online_url = "https://workwechat.vipzhhr.com"
            // this.agentId = '1000048'
            // this.baseUrl = 'https://testv1.vipzhhr.com'
        }

        // 设置环境变量状态，方便首页原生js获取环境变量状态
        localStorage.setItem('env',this.env)
    },
}

// 环境初始化
env.init()

export default env